// extracted by mini-css-extract-plugin
module.exports = {"font-royal-loudes":"david-fonts_font-royal-loudes__VxmY8","font-royal-loudes-rough":"david-fonts_font-royal-loudes-rough__IdaJ7"};